export const labels = {
	title: {
		label: "Label.MobileCreator.UnrecoverableErrorRefresh.Title",
		default: "Unexpected error occured.",
	},
	message: {
		label: "Label.MobileCreator.UnrecoverableErrorRefresh.Message",
		default: "We registered your error with ID: {0}.",
	},
	refresh: {
		label: "Label.MobileCreator.UnrecoverableErrorRefresh.Refresh",
		default: "Refresh",
	},
	home: {
		label: "Label.MobileCreator.UnrecoverableErrorRefresh.Home",
		default: "Home",
	},
} as const;
